"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toCBOR = void 0;
var cbor_1 = __importDefault(require("cbor"));
var bigNumberToArray = function (v) {
    var tmp;
    // Adding byte sign
    var signByte = "00";
    if (v.lt(0)) {
        signByte = "01";
    }
    if (v.toString() === "") {
        // to test with null bigint
        return Buffer.from(signByte, "hex");
    }
    else {
        tmp = v.toString(16);
        // not sure why it is not padding and buffer does not like it
        if (tmp.length % 2 === 1)
            tmp = "0" + tmp;
    }
    return Buffer.concat([Buffer.from(signByte, "hex"), Buffer.from(tmp, "hex")]);
};
var toCBOR = function (from, recipient, tx) {
    var method = tx.method, version = tx.version, nonce = tx.nonce, gasLimit = tx.gasLimit, gasPremium = tx.gasPremium, gasFeeCap = tx.gasFeeCap, params = tx.params, amount = tx.amount;
    var answer = [];
    // "version" field
    answer.push(version);
    // "to" field
    answer.push(recipient);
    // "from" field
    answer.push(from);
    // "nonce" field
    answer.push(nonce);
    // "value"
    var buf = bigNumberToArray(amount);
    answer.push(buf);
    // "gaslimit"
    answer.push(gasLimit.toNumber());
    // "gasfeecap"
    buf = bigNumberToArray(gasFeeCap);
    answer.push(buf);
    // "gaspremium"
    buf = bigNumberToArray(gasPremium);
    answer.push(buf);
    // "method"
    answer.push(method);
    if (params)
        answer.push(params);
    else
        answer.push(Buffer.alloc(0));
    return cbor_1["default"].encode(answer);
};
exports.toCBOR = toCBOR;
//# sourceMappingURL=serializer.js.map